module.exports = __webpack_public_path__ + "media/Pro Magic Reveal.bca78b14.wav";